import React, { memo, useCallback } from "react";
import moment from "moment";
import OrderDTO from "@/dto/order/OrderDTO";

type Props = {
    order: OrderDTO;
};

const PaymentTimeColumn: React.FC<Props> = ({ order }) => {
    // 已付款n分钟...
    const buildFromPay = useCallback((paymentTime) => {
        const secondsFromPay = moment().diff(paymentTime, "seconds");

        let duration;
        let unit;

        if (secondsFromPay > 86400) {
            // days
            duration = Math.floor(secondsFromPay / 86400);
            unit = "天";
        } else if (secondsFromPay > 3600) {
            // hours
            duration = Math.floor(secondsFromPay / 3600);
            unit = "小时";
        } else if (secondsFromPay > 60) {
            duration = Math.floor(secondsFromPay / 60);
            unit = "分钟";
        } else if (secondsFromPay < 0) {
            return null;
        } else {
            duration = secondsFromPay;
            unit = "秒";
        }

        if (secondsFromPay > 43200) {
            // 大于12小时
            return (
                <p className="mt5 text-danger fb">
                    已付款{duration}
                    {unit}
                </p>
            );
        }

        return (
            <p className="mt5 text-gray fs12">
                已付款{duration}
                {unit}
            </p>
        );
    }, []);

    if (!order.paymentTime) {
        return <td />;
    }

    return (
        <td>
            {order.paymentTime?.split(" ").map((str, index) => (
                <p key={index}>{str}</p>
            ))}
            {buildFromPay(order.paymentTime)}
        </td>
    );
};

export default memo(PaymentTimeColumn, (prev, next) => prev.order.paymentTime === next.order.paymentTime);
